module.exports = __webpack_public_path__ + "img/sn.6f881f4f.svg";